import { createContext } from "react";

export const AppContext = createContext({
  flyoutMessage: "",
  showFlyout: () => {},
  loaderVisible: false,
  toggleLoaderVisibility: () => {},
});
